// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 787 ? "plotly" : chunkId) + "." + {"787":"44697f02","821":"cbf0e396"}[chunkId] + ".chunk.js";
};